"use client";

import React from "react";
import { useNavigate } from "react-router";
import { Button } from "react-bootstrap";
import styles from "../components/auth/LoginForm.module.css";

export default function WheelNotFound() {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <div className={styles.loginCard}>
                <div className={styles.logoSection}>
                    <img
                        src="/splash400_stage.png"
                        alt="Artifacts"
                        className={styles.logo}
                        style={{ width: 400, height: 400, objectFit: 'contain' }}
                    />
                </div>
                <h2 className={styles.title}>404</h2>
                <p className={styles.subtitle}>Страница не найдена</p>
                <Button
                    variant="primary"
                    onClick={() => navigate('/')}
                    className={styles.button}
                    style={{ marginTop: '20px' }}
                >
                    Вернуться на главную
                </Button>
            </div>
        </div>
    );
}